const normolizeBootcampToReviews = (data) => {
  if (!data) return null;
  const newData = {};
  data.forEach(
    (info) =>
      (newData[
        info.node.bootcamp
      ] = info.node.reviews.content[0].content[0].value
        .split(",")
        .map((nick) => nick.trim()))
  );
  return newData;
};
export default normolizeBootcampToReviews;
